export class Time {
  accumulator: number
  last: number
  delta: number
  fixedDelta: number
  FPS: number
  constructor(fixedDelta = 1 / 60) {
    this.last = performance.now()
    this.delta = 0
    this.accumulator = 0
    this.fixedDelta = fixedDelta
    this.FPS = 0
  }
  manageFixedUpdate(func: () => void) {
    let maxCount = 2
    if (this.accumulator > this.fixedDelta * maxCount) this.accumulator = this.fixedDelta * maxCount
    while (this.accumulator >= this.fixedDelta) {
      func()
      this.accumulator -= this.fixedDelta
    }
  }
  update() {
    const now = performance.now()
    this.delta = (now - this.last) / 1000
    this.last = now
    this.accumulator += this.delta
    this.FPS = 1 / this.delta
  }
}
